module.exports = __webpack_public_path__ + "img/table-empty.20da5829.png";